export const EnumMobile = {
  /** 移动端 */
  mobile: '/accountm/',
};
